import { useVisibilityReturn } from '@p2p/shared/hooks';
import { useState } from 'react';

import { PaidConfirmModal } from '../../../PaidConfirmModal/PaidConfirmModal';

type QRReturnModalProps = {
  onSuccess: () => void;
  onClose: () => void;
};

export const QRReturnModal = ({ onSuccess, onClose }: QRReturnModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  useVisibilityReturn(() => setIsOpen(true));

  const handleSuccess = () => {
    setIsOpen(false);
    onSuccess();
  };

  const handleClose = () => {
    setIsOpen(false);
    onClose();
  };

  return <PaidConfirmModal open={isOpen} onSuccess={handleSuccess} onClose={handleClose} />;
};
